var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"acceptation-form"},[_c('submit-button',{attrs:{"buttonText":"Accept the item","isPrimary":false,"isLoading":_vm.isSubmitting,"disabled":_vm.isDisabled}}),_c('form-errors',{attrs:{"formErrors":_vm.submitErrors}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }